import React, { useState } from 'react';
import './AddDriversToPoolOption.scss';

interface AddDriversToPoolOptionProps {
    index: number;
    driverId: string | undefined;
    driverName: string | undefined;
    jobName: string | null | undefined;
    isListTypeSelected: boolean;
    isSelected: boolean;
    onClick: (event, index, id: number, isListTypeSelected: boolean) => void;
}

const AddDriversToPoolOption = ({
    index,
    driverId,
    driverName,
    jobName,
    isListTypeSelected,
    isSelected,
    onClick,
}: AddDriversToPoolOptionProps): React.ReactElement => {
    const handelOnClick = (e, index: number, id: number, isListTypeSelected: boolean) => {
        document.getElementById(id.toString())?.classList.toggle('DriverPool-Drivers-List-Selected');
        onClick(e, index, id, isListTypeSelected);
    };

    return (
        <div
            className={
                isSelected ? 'DriverPool-Drivers-List DriverPool-Drivers-List-Selected' : 'DriverPool-Drivers-List'
            }
            id={driverId}
            onClick={e => handelOnClick(e, index, parseInt((e.target as HTMLInputElement).id), isListTypeSelected)}
        >
            {driverName}
            <span className="DriverPool-Drivers-List-Pool">{jobName ? ` (Pool: ${jobName})` : ''}</span>
        </div>
    );
};

export default AddDriversToPoolOption;
